/**
 * デバッグユーティリティ
 * 環境変数でデバッグログの有効/無効を制御
 */

const DEBUG_ENABLED = process.env.NODE_ENV === 'development' && process.env.REACT_APP_DEBUG === 'true';

interface Debug {
  log: (namespace: string, message: string, ...data: any[]) => void;
  warn: (namespace: string, message: string, ...data: any[]) => void;
  error: (namespace: string, message: string, ...data: any[]) => void;
  group: (namespace: string, title: string) => void;
  groupCollapsed: (namespace: string, title: string) => void;
  groupEnd: () => void;
  table: (data: any) => void;
  info: (namespace: string, message: string, ...data: any[]) => void;
}

/**
 * デバッグログを出力
 * @param {string} namespace - ログのカテゴリ (例: 'GridCalendar', 'API')
 * @param {string} message - ログメッセージ
 * @param {any} data - 追加データ
 */
export const debug: Debug = {
  log: (namespace: string, message: string, ...data: any[]): void => {
    if (DEBUG_ENABLED) {
      if (data.length > 0) {
        console.log(`[${namespace}] ${message}`, ...data);
      } else {
        console.log(`[${namespace}] ${message}`);
      }
    }
  },

  warn: (namespace: string, message: string, ...data: any[]): void => {
    if (DEBUG_ENABLED) {
      if (data.length > 0) {
        console.warn(`[${namespace}] ${message}`, ...data);
      } else {
        console.warn(`[${namespace}] ${message}`);
      }
    }
  },

  error: (namespace: string, message: string, ...data: any[]): void => {
    // エラーは常に出力
    if (data.length > 0) {
      console.error(`[${namespace}] ${message}`, ...data);
    } else {
      console.error(`[${namespace}] ${message}`);
    }
  },

  group: (namespace: string, title: string): void => {
    if (DEBUG_ENABLED) {
      console.group(`[${namespace}] ${title}`);
    }
  },

  groupCollapsed: (namespace: string, title: string): void => {
    if (DEBUG_ENABLED) {
      console.groupCollapsed(`[${namespace}] ${title}`);
    }
  },

  groupEnd: (): void => {
    if (DEBUG_ENABLED) {
      console.groupEnd();
    }
  },

  table: (data: any): void => {
    if (DEBUG_ENABLED) {
      console.table(data);
    }
  },

  info: (namespace: string, message: string, ...data: any[]): void => {
    if (DEBUG_ENABLED) {
      if (data.length > 0) {
        console.info(`[${namespace}] ${message}`, ...data);
      } else {
        console.info(`[${namespace}] ${message}`);
      }
    }
  }
};

export default debug;
